// 导入各模块的英语翻译文件
import pages from '../namespaces/pages/en';
import components from '../namespaces/components/en';
import common from '../namespaces/common/en';
import errors from '../namespaces/errors/en';
import validation from '../namespaces/validation/en';
import gameDetail from '../namespaces/gameDetail/en';

// 导出合并后的翻译
export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
}; 